"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countriesKeyedByIsoCode = exports.countries = exports.nonPriorityCountries = exports.priorityCountries = void 0;
exports.priorityCountries = [
    {
        label: 'United States',
        value: 'United States',
        isoCode: 'US',
        countryCode: '+1',
        flag: '🇺🇸',
    },
    {
        label: 'Canada',
        value: 'Canada',
        isoCode: 'CA',
        countryCode: '+1',
        flag: '🇨🇦',
    },
    {
        label: 'United Kingdom',
        value: 'United Kingdom',
        isoCode: 'GB',
        countryCode: '+44',
        flag: '🇬🇧',
    },
];
exports.nonPriorityCountries = [
    {
        label: 'Algeria',
        value: 'Algeria',
        isoCode: 'DZ',
        countryCode: '+213',
        flag: '🇩🇿',
    },
    {
        label: 'Argentina',
        value: 'Argentina',
        isoCode: 'AR',
        countryCode: '+54',
        flag: '🇦🇷',
    },
    {
        label: 'Armenia',
        value: 'Armenia',
        isoCode: 'AM',
        countryCode: '+374',
        flag: '🇦🇲',
    },
    {
        label: 'Aruba',
        value: 'Aruba',
        isoCode: 'AW',
        countryCode: '+297',
        flag: '🇦🇼',
    },
    {
        label: 'Australia',
        value: 'Australia',
        isoCode: 'AU',
        countryCode: '+61',
        flag: '🇦🇺',
    },
    {
        label: 'Austria',
        value: 'Austria',
        isoCode: 'AT',
        countryCode: '+43',
        flag: '🇦🇹',
    },
    {
        label: 'Azerbaijan',
        value: 'Azerbaijan',
        isoCode: 'AZ',
        countryCode: '+994',
        flag: '🇦🇿',
    },
    {
        label: 'Bahamas',
        value: 'Bahamas',
        isoCode: 'BS',
        countryCode: '+1242',
        flag: '🇧🇸',
    },
    {
        label: 'Bahrain',
        value: 'Bahrain',
        isoCode: 'BH',
        countryCode: '+973',
        flag: '🇧🇭',
    },
    {
        label: 'Bangladesh',
        value: 'Bangladesh',
        isoCode: 'BD',
        countryCode: '+880',
        flag: '🇧🇩',
    },
    {
        label: 'Barbados',
        value: 'Barbados',
        isoCode: 'BB',
        countryCode: '+1246',
        flag: '🇧🇧',
    },
    {
        label: 'Belgium',
        value: 'Belgium',
        isoCode: 'BE',
        countryCode: '+32',
        flag: '🇧🇪',
    },
    {
        label: 'Bermuda',
        value: 'Bermuda',
        isoCode: 'BM',
        countryCode: '+1441',
        flag: '🇧🇲',
    },
    {
        label: 'Bolivia',
        value: 'Bolivia',
        isoCode: 'BO',
        countryCode: '+591',
        flag: '🇧🇴',
    },
    {
        label: 'Brazil',
        value: 'Brazil',
        isoCode: 'BR',
        countryCode: '+55',
        flag: '🇧🇷',
    },
    {
        label: 'Bulgaria',
        value: 'Bulgaria',
        isoCode: 'BG',
        countryCode: '+359',
        flag: '🇧🇬',
    },
    {
        label: 'Cambodia',
        value: 'Cambodia',
        isoCode: 'KH',
        countryCode: '+855',
        flag: '🇰🇭',
    },
    {
        label: 'Cameroon',
        value: 'Cameroon',
        isoCode: 'CM',
        countryCode: '+237',
        flag: '🇨🇲',
    },
    {
        label: 'Chile',
        value: 'Chile',
        isoCode: 'CL',
        countryCode: '+56',
        flag: '🇨🇱',
    },
    {
        label: 'Colombia',
        value: 'Colombia',
        isoCode: 'CO',
        countryCode: '+57',
        flag: '🇨🇴',
    },
    {
        label: 'Costa Rica',
        value: 'Costa Rica',
        isoCode: 'CR',
        countryCode: '+506',
        flag: '🇨🇷',
    },
    {
        label: 'Croatia',
        value: 'Croatia',
        isoCode: 'HR',
        countryCode: '+385',
        flag: '🇭🇷',
    },
    {
        label: 'Cyprus',
        value: 'Cyprus',
        isoCode: 'CY',
        countryCode: '+357',
        flag: '🇨🇾',
    },
    {
        label: 'Czech Republic',
        value: 'Czech Republic',
        isoCode: 'CZ',
        countryCode: '+420',
        flag: '🇨🇿',
    },
    {
        label: 'Denmark',
        value: 'Denmark',
        isoCode: 'DK',
        countryCode: '+45',
        flag: '🇩🇰',
    },
    {
        label: 'Dominican Republic',
        value: 'Dominican Republic',
        isoCode: 'DO',
        countryCode: '+1849',
        flag: '🇩🇴',
    },
    {
        label: 'Ecuador',
        value: 'Ecuador',
        isoCode: 'EC',
        countryCode: '+593',
        flag: '🇪🇨',
    },
    {
        label: 'Egypt',
        value: 'Egypt',
        isoCode: 'EG',
        countryCode: '+20',
        flag: '🇪🇬',
    },
    {
        label: 'El Salvador',
        value: 'El Salvador',
        isoCode: 'SV',
        countryCode: '+503',
        flag: '🇸🇻',
    },
    {
        label: 'Estonia',
        value: 'Estonia',
        isoCode: 'EE',
        countryCode: '+372',
        flag: '🇪🇪',
    },
    {
        label: 'Ethiopia',
        value: 'Ethiopia',
        isoCode: 'ET',
        countryCode: '+251',
        flag: '🇪🇹',
    },
    {
        label: 'Finland',
        value: 'Finland',
        isoCode: 'FI',
        countryCode: '+358',
        flag: '🇫🇮',
    },
    {
        label: 'France',
        value: 'France',
        isoCode: 'FR',
        countryCode: '+33',
        flag: '🇫🇷',
    },
    {
        label: 'Gabon',
        value: 'Gabon',
        isoCode: 'GA',
        countryCode: '+241',
        flag: '🇬🇦',
    },
    {
        label: 'Georgia',
        value: 'Georgia',
        isoCode: 'GE',
        countryCode: '+995',
        flag: '🇬🇪',
    },
    {
        label: 'Germany',
        value: 'Germany',
        isoCode: 'DE',
        countryCode: '+49',
        flag: '🇩🇪',
    },
    {
        label: 'Ghana',
        value: 'Ghana',
        isoCode: 'GH',
        countryCode: '+233',
        flag: '🇬🇭',
    },
    {
        label: 'Greece',
        value: 'Greece',
        isoCode: 'GR',
        countryCode: '+30',
        flag: '🇬🇷',
    },
    {
        label: 'Guatemala',
        value: 'Guatemala',
        isoCode: 'GT',
        countryCode: '+502',
        flag: '🇬🇹',
    },
    {
        label: 'Honduras',
        value: 'Honduras',
        isoCode: 'HN',
        countryCode: '+504',
        flag: '🇭🇳',
    },
    {
        label: 'Hong Kong',
        value: 'Hong Kong',
        isoCode: 'HK',
        countryCode: '+852',
        flag: '🇭🇰',
    },
    {
        label: 'Hungary',
        value: 'Hungary',
        isoCode: 'HU',
        countryCode: '+36',
        flag: '🇭🇺',
    },
    {
        label: 'Iceland',
        value: 'Iceland',
        isoCode: 'IS',
        countryCode: '+354',
        flag: '🇮🇸',
    },
    {
        label: 'India',
        value: 'India',
        isoCode: 'IN',
        countryCode: '+91',
        flag: '🇮🇳',
    },
    {
        label: 'Indonesia',
        value: 'Indonesia',
        isoCode: 'ID',
        countryCode: '+62',
        flag: '🇮🇩',
    },
    {
        label: 'Ireland',
        value: 'Ireland',
        isoCode: 'IE',
        countryCode: '+353',
        flag: '🇮🇪',
    },
    {
        label: 'Israel',
        value: 'Israel',
        isoCode: 'IL',
        countryCode: '+972',
        flag: '🇮🇱',
    },
    {
        label: 'Italy',
        value: 'Italy',
        isoCode: 'IT',
        countryCode: '+39',
        flag: '🇮🇹',
    },
    {
        label: 'Jamaica',
        value: 'Jamaica',
        isoCode: 'JM',
        countryCode: '+1876',
        flag: '🇯🇲',
    },
    {
        label: 'Japan',
        value: 'Japan',
        isoCode: 'JP',
        countryCode: '+81',
        flag: '🇯🇵',
    },
    {
        label: 'Jordan',
        value: 'Jordan',
        isoCode: 'JO',
        countryCode: '+962',
        flag: '🇯🇴',
    },
    {
        label: 'Kazakhstan',
        value: 'Kazakhstan',
        isoCode: 'KZ',
        countryCode: '+7',
        flag: '🇰🇿',
    },
    {
        label: 'Kenya',
        value: 'Kenya',
        isoCode: 'KE',
        countryCode: '+254',
        flag: '🇰🇪',
    },
    {
        label: 'Kuwait',
        value: 'Kuwait',
        isoCode: 'KW',
        countryCode: '+965',
        flag: '🇰🇼',
    },
    {
        label: 'Latvia',
        value: 'Latvia',
        isoCode: 'LV',
        countryCode: '+371',
        flag: '🇱🇻',
    },
    {
        label: 'Lesotho',
        value: 'Lesotho',
        isoCode: 'LS',
        countryCode: '+266',
        flag: '🇱🇸',
    },
    {
        label: 'Liechtenstein',
        value: 'Liechtenstein',
        isoCode: 'LI',
        countryCode: '+423',
        flag: '🇱🇮',
    },
    {
        label: 'Lithuania',
        value: 'Lithuania',
        isoCode: 'LT',
        countryCode: '+370',
        flag: '🇱🇹',
    },
    {
        label: 'Luxembourg',
        value: 'Luxembourg',
        isoCode: 'LU',
        countryCode: '+352',
        flag: '🇱🇺',
    },
    {
        label: 'Malaysia',
        value: 'Malaysia',
        isoCode: 'MY',
        countryCode: '+60',
        flag: '🇲🇾',
    },
    {
        label: 'Malta',
        value: 'Malta',
        isoCode: 'MT',
        countryCode: '+356',
        flag: '🇲🇹',
    },
    {
        label: 'Mauritius',
        value: 'Mauritius',
        isoCode: 'MU',
        countryCode: '+230',
        flag: '🇲🇺',
    },
    {
        label: 'Mexico',
        value: 'Mexico',
        isoCode: 'MX',
        countryCode: '+52',
        flag: '🇲🇽',
    },
    {
        label: 'Monaco',
        value: 'Monaco',
        isoCode: 'MC',
        countryCode: '+377',
        flag: '🇲🇨',
    },
    {
        label: 'Morocco',
        value: 'Morocco',
        isoCode: 'MA',
        countryCode: '+212',
        flag: '🇲🇦',
    },
    {
        label: 'Namibia',
        value: 'Namibia',
        isoCode: 'NA',
        countryCode: '+264',
        flag: '🇳🇦',
    },
    {
        label: 'Nepal',
        value: 'Nepal',
        isoCode: 'NP',
        countryCode: '+977',
        flag: '🇳🇵',
    },
    {
        label: 'Netherlands',
        value: 'Netherlands',
        isoCode: 'NL',
        countryCode: '+31',
        flag: '🇳🇱',
    },
    {
        label: 'New Caledonia',
        value: 'New Caledonia',
        isoCode: 'NC',
        countryCode: '+687',
        flag: '🇳🇨',
    },
    {
        label: 'New Zealand',
        value: 'New Zealand',
        isoCode: 'NZ',
        countryCode: '+64',
        flag: '🇳🇿',
    },
    {
        label: 'Nicaragua',
        value: 'Nicaragua',
        isoCode: 'NI',
        countryCode: '+505',
        flag: '🇳🇮',
    },
    {
        label: 'Nigeria',
        value: 'Nigeria',
        isoCode: 'NG',
        countryCode: '+234',
        flag: '🇳🇬',
    },
    {
        label: 'Norway',
        value: 'Norway',
        isoCode: 'NO',
        countryCode: '+47',
        flag: '🇳🇴',
    },
    {
        label: 'Oman',
        value: 'Oman',
        isoCode: 'OM',
        countryCode: '+968',
        flag: '🇴🇲',
    },
    {
        label: 'Pakistan',
        value: 'Pakistan',
        isoCode: 'PK',
        countryCode: '+92',
        flag: '🇵🇰',
    },
    {
        label: 'Panama',
        value: 'Panama',
        isoCode: 'PA',
        countryCode: '+507',
        flag: '🇵🇦',
    },
    {
        label: 'Papua New',
        value: 'Papua New Guinea',
        isoCode: 'PG',
        countryCode: '+675',
        flag: '🇵🇬',
    },
    {
        label: 'Paraguay',
        value: 'Paraguay',
        isoCode: 'PY',
        countryCode: '+595',
        flag: '🇵🇾',
    },
    {
        label: 'Peru',
        value: 'Peru',
        isoCode: 'PE',
        countryCode: '+51',
        flag: '🇵🇪',
    },
    {
        label: 'Philippines',
        value: 'Philippines',
        isoCode: 'PH',
        countryCode: '+63',
        flag: '🇵🇭',
    },
    {
        label: 'Poland',
        value: 'Poland',
        isoCode: 'PL',
        countryCode: '+48',
        flag: '🇵🇱',
    },
    {
        label: 'Portugal',
        value: 'Portugal',
        isoCode: 'PT',
        countryCode: '+351',
        flag: '🇵🇹',
    },
    {
        label: 'Qatar',
        value: 'Qatar',
        isoCode: 'QA',
        countryCode: '+974',
        flag: '🇶🇦',
    },
    {
        label: 'Romania',
        value: 'Romania',
        isoCode: 'RO',
        countryCode: '+40',
        flag: '🇷🇴',
    },
    {
        label: 'Rwanda',
        value: 'Rwanda',
        isoCode: 'RW',
        countryCode: '+250',
        flag: '🇷🇼',
    },
    {
        label: 'Saudi Arabia',
        value: 'Saudi Arabia',
        isoCode: 'SA',
        countryCode: '+966',
        flag: '🇸🇦',
    },
    {
        label: 'Senegal',
        value: 'Senegal',
        isoCode: 'SN',
        countryCode: '+221',
        flag: '🇸🇳',
    },
    {
        label: 'Singapore',
        value: 'Singapore',
        isoCode: 'SG',
        countryCode: '+65',
        flag: '🇸🇬',
    },
    {
        label: 'Slovakia',
        value: 'Slovakia',
        isoCode: 'SK',
        countryCode: '+421',
        flag: '🇸🇰',
    },
    {
        label: 'Slovenia',
        value: 'Slovenia',
        isoCode: 'SI',
        countryCode: '+386',
        flag: '🇸🇮',
    },
    {
        label: 'South Africa',
        value: 'South Africa',
        isoCode: 'ZA',
        countryCode: '+27',
        flag: '🇿🇦',
    },
    {
        label: 'South Korea',
        value: 'Korea',
        isoCode: 'KR',
        countryCode: '+82',
        flag: '🇰🇷',
    },
    {
        label: 'Spain',
        value: 'Spain',
        isoCode: 'ES',
        countryCode: '+34',
        flag: '🇪🇸',
    },
    {
        label: 'Sri Lanka',
        value: 'Sri Lanka',
        isoCode: 'LK',
        countryCode: '+94',
        flag: '🇱🇰',
    },
    {
        label: 'Swaziland',
        value: 'Swaziland',
        isoCode: 'SZ',
        countryCode: '+268',
        flag: '🇸🇿',
    },
    {
        label: 'Sweden',
        value: 'Sweden',
        isoCode: 'SE',
        countryCode: '+46',
        flag: '🇸🇪',
    },
    {
        label: 'Switzerland',
        value: 'Switzerland',
        isoCode: 'CH',
        countryCode: '+41',
        flag: '🇨🇭',
    },
    {
        label: 'Taiwan',
        value: 'Taiwan',
        isoCode: 'TW',
        countryCode: '+886',
        flag: '🇹🇼',
    },
    {
        label: 'Thailand',
        value: 'Thailand',
        isoCode: 'TH',
        countryCode: '+66',
        flag: '🇹🇭',
    },
    {
        label: 'Tonga',
        value: 'Tonga',
        isoCode: 'TO',
        countryCode: '+676',
        flag: '🇹🇴',
    },
    {
        label: 'Tunisia',
        value: 'Tunisia',
        isoCode: 'TN',
        countryCode: '+216',
        flag: '🇹🇳',
    },
    {
        label: 'Turkey',
        value: 'Turkey',
        isoCode: 'TR',
        countryCode: '+90',
        flag: '🇹🇷',
    },
    {
        label: 'United Arab Emirates',
        value: 'United Arab Emirates',
        isoCode: 'AE',
        countryCode: '+971',
        flag: '🇦🇪',
    },
    {
        label: 'Uruguay',
        value: 'Uruguay',
        isoCode: 'UY',
        countryCode: '+598',
        flag: '🇺🇾',
    },
    {
        label: 'Uzbekistan',
        value: 'Uzbekistan',
        isoCode: 'UZ',
        countryCode: '+998',
        flag: '🇺🇿',
    },
    {
        label: 'Viet Nam',
        value: 'Viet Nam',
        isoCode: 'VN',
        countryCode: '+84',
        flag: '🇻🇳',
    },
    {
        label: 'Western Sahara',
        value: 'Western Sahara',
        isoCode: 'EH',
        countryCode: '+212',
        flag: '🇪🇭',
    },
    {
        label: 'Zambia',
        value: 'Zambia',
        isoCode: 'ZM',
        countryCode: '+260',
        flag: '🇿🇲',
    },
];
exports.countries = [...exports.priorityCountries, ...exports.nonPriorityCountries];
exports.countriesKeyedByIsoCode = exports.countries.reduce((obj, country) => (Object.assign(Object.assign({}, obj), { [country.isoCode]: country })), {});
//# sourceMappingURL=countries.js.map